import React from 'react';
import DailyVisitorStats from './components/DailyVisitorStats';
import AdvancedAnalytics from './components/AdvancedAnalytics';
import './AdminAnalyticsPage.css';

const AdminAnalyticsPage = () => {
  return (
    <div className="admin-analytics-page">
      <div className="admin-analytics-container">
        <div className="admin-analytics-header">
          <div className="admin-analytics-breadcrumb">
            <span className="admin-analytics-breadcrumb-link">Home</span>
            <span className="admin-analytics-breadcrumb-separator">›</span>
            <span className="admin-analytics-breadcrumb-current">Analytics</span>
          </div>
          <h1 className="admin-analytics-title">Analytics Dashboard</h1>
        </div>

        <div className="admin-analytics-hero">
          <p className="admin-analytics-subtitle">
            Track daily visitors, page views, and explore Firebase data.
          </p>
        </div>
      </div>
      
      <div className="analytics-content">
        {/* Daily Visitor Statistics */}
        <DailyVisitorStats />
        
        {/* Advanced Analytics */}
        <AdvancedAnalytics />
      </div>
    </div>
  );
};

export default AdminAnalyticsPage;